import React from 'react'
import "./css/TopBar.css"
import { Navbar, Nav, Dropdown, Container, NavDropdown } from 'react-bootstrap'
import FullscreenBtn from "../../CommonComponents/FullscreenBtn"

export default function TopBar(props) {

        function renderProjectNames() {
                return Object.keys(props.projects).map((key) => {
                        if (key !== props.current_project_key) {
                                return (
                                        <Dropdown.Item key={key} href={`/project/preprocessing/${key}`}>
                                                {props.projects[key]}
                                        </Dropdown.Item>
                                )
                        }
                        else {
                                return null
                        }
                }
                )
        }
        return (
                <Navbar id="main-topbar" fixed="top" collapseOnSelect expand="lg" variant="dark" style={{ zIndex: "10", backgroundColor: "#000000" }}>
                        <Container fluid>
                                <FullscreenBtn element_id="main-dashboard-container" />

                                <Navbar.Brand id="navbar_brand">
                                        <label id="project_brand_label" className="m-0 pt-2">{props.projects[props.current_project_key]}</label>
                                </Navbar.Brand>
                                
                                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                                <Navbar.Collapse id="responsive-navbar-nav">
                                        <Nav className="me-auto w-100" >
                                                <Nav.Link className="mr-3 text-light" href={`/settings/${props.current_project_key}`}>Settings</Nav.Link>
                                                <NavDropdown title="Select Project" style={{color: "white"}}>
                                                        {renderProjectNames()}
                                                        <NavDropdown.Divider />
                                                        <NavDropdown.Item href="/workspace">Workspace</NavDropdown.Item>
                                                </NavDropdown>
                                        </Nav>
                                        <Nav.Link className="mr-5" href={`/user_profile`}>
                                                <img height="40" src={process.env.PUBLIC_URL + "/images/Dashboard/user_profile.png"} alt="user"></img>
                                        </Nav.Link>
                                </Navbar.Collapse>
                        </Container>
                </Navbar>
        )
}
